import { Component } from 'react';
import {observer} from "mobx-react";

import TagFilter from './TagFilter';
import {StoreContext} from "../../../stores/StoreLoader";

@observer
export default class TagFilters extends Component {
    static contextType = StoreContext;

    constructor(props) {
        super(props);
    }

    render() {
        const { gridStore } = this.context;

        const tags = gridStore.tagFilters.filters;
        const numTags = tags.size;

        if (numTags > 0) {
            return (
                <span className="sb-collection-filter-bar-row">
                    <span className="sb-collection-filter-bar-text">and click to see who is </span>
                    {
                        tags.values().map((tag, index) => {
                            return <TagFilter key={tag.id} tagId={tag.id}
                                              tagIndex={index}
                                              numTags={numTags}
                            />;
                        })
                    }
                </span>
            );
        }

        return null;
    }
}
